import {
  ButtonGroup,
  Flex,
  FormControl,
  SimpleGrid,
  Stack,
  Text,
} from "@chakra-ui/react";
import React from "react";
import { useTranslation } from "react-i18next";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate, useParams } from "react-router-dom";
import Card from "../../../components/card/Card";
import CustomButton from "../../../components/Common/CustomButton";
import IsLoading from "../../../components/Common/IsLoading";
import { selectFormData, selectLoading } from "./redux/selector";
import { actions } from "./redux/slice";
import { IS_RETAILER, path } from "../../../utils/Api";
import { EnquiryType } from "./types";

const Create = () => {
  const { t } = useTranslation();
  const params = useParams();
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const form = useSelector(selectFormData);
  const loader = useSelector(selectLoading);

  React.useEffect(() => {
    if (params.id) {
      dispatch(actions.doGetById(params?.id));
    }
    return () => {};
  }, [params.id]);

  const handleCancel = () => {
    dispatch(actions.clearFrom());
    navigate(-1);
  };

  const FieldRow = ({
    label,
    value,
    isImage = false,
    isLink = false,
  }: {
    label: string;
    value: string;
    isImage?: boolean;
    isLink?: boolean;
  }) => (
    <Flex mb={4}>
      <Text fontWeight="semibold" mb={1} minW="200px">
        {label}:
      </Text>
      {isImage && value ? (
        <img
          src={path() + value}
          alt={label}
          style={{ maxWidth: "50px", borderRadius: "8px" }}
          onClick={() => {
            window.open(path() + value, "_blank");
          }}
        />
      ) : isLink && value ? (
        <a
          href={value}
          target="_blank"
          rel="noopener noreferrer"
          style={{ color: "#3182CE" }}
        >
          {value}
        </a>
      ) : (
        <Text fontWeight="light">{value || "-"} </Text>
      )}
    </Flex>
  );

  const retailerForm = [
    { label: t("contactUs.form.name"), value: form?.name },
    { label: t("contactUs.form.email"), value: form?.email },
    { label: t("contactUs.form.phone"), value: form?.mobileNumber },
    { label: t("contactUs.form.description"), value: form?.description },
    { label: t("contactUs.form.companyName"), value: form?.companyName },
  ];

  const userForm = [
    { label: t("contactUs.form.name"), value: form?.name },
    { label: t("contactUs.form.email"), value: form?.email },
    { label: t("contactUs.form.phone"), value: form?.mobileNumber },
    { label: t("contactUs.form.description"), value: form?.description },
    { label: t("contactUs.form.file"), value: form?.file, isImage: true },
    {
      label: t("contactUs.form.enquiryType"),
      value:
        form?.enquiryType === EnquiryType.ENQUIRY
          ? t("contactUs.form.enquiryType")
          : t("contactUs.form.about"),
    },
  ];
  const fieldsToRender = IS_RETAILER === "true" ? retailerForm : userForm;
  return (
    <Flex pt={{ base: "130px", md: "80px", xl: "80px" }}>
      <Card>
        {loader ? (
          <IsLoading />
        ) : (
          <FormControl>
            <Stack spacing={4}>
              {fieldsToRender.map((item, index) => (
                <FieldRow
                  key={index}
                  label={item.label}
                  value={String(item.value)}
                  // isImage={item?.isImage ?? false}
                  // isLink={item.isLink ?? false}
                />
              ))}
            </Stack>

            <SimpleGrid columns={1} spacing={10}>
              <Flex flexDirection="column">
                <ButtonGroup justifyContent={"flex-end"} mt={8}>
                  <CustomButton
                    handleClick={handleCancel}
                    title={t("common.button.cancel")}
                    loading={false}
                    variant="light"
                    sx={{ marginRight: "20px" }}
                  />
                </ButtonGroup>
              </Flex>
            </SimpleGrid>
          </FormControl>
        )}
      </Card>
    </Flex>
  );
};

export default Create;
